import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Vocabulary } from "../Vocabulary";

export const ROUTER_MANAGE_CALENDAR = {
  routes: ["/calendar", "*"],
};

export const MAIN_SLIDER_MANAGE_CALENDAR = [
  {
    name: Vocabulary.calendarName,
    path: "/calendar",
    icon: <CalendarMonthIcon />,
    orderId: 4,
    group: Vocabulary.navGroupNavigation,
  },
];

export const VEHICLE_OPTIONS_MANAGE_CALENDAR = [];

export const DINAMIC_TABS_MANAGE_CALENDAR = {};

export const MAIN_TABLE_MANAGE_CALENDAR = null;
